import { endpoints, baseurl } from "../Utils/Constants";

export const saveLoginCreds = async (data, token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.SAVE_LOGIN_CREDS}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error saving login credentials:", error);
        throw error;
    }
};

export const getAllLoginCreds = async (token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_ALL_LOGIN_CREDS}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching login credentials:", error);
        throw error;
    }
};

export const getLoginCredsById = async (id, token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.GET_LOGIN_CREDS_BY_ID}${id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error fetching login credentials by ID:", error);
        throw error;
    }
};

export const deleteLoginCreds = async (id, token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.DELETE_LOGIN_CREDS}${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error deleting login credentials:", error);
        throw error;
    }
};

export const loadTitles = async (token) => {
    try {
        const response = await fetch(`${baseurl}${endpoints.LOAD_TITLES}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const result = await response.json();
        return result;
    } catch (error) {
        console.error("Error loading titles:", error);
        throw error;
    }
};
